import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { getCellStyles } from './hooks/getCellStyles'

export const BodyCell = styled.td`
  ${getCellStyles()};
  padding: ${Spacing.S16};
`
